export type BadgeColor = 'green' | 'gold' | 'red' | 'gray' | 'blue'

export default function Badge({ color = 'gray', children }: { color?: BadgeColor; children: React.ReactNode }) {
  return <span className={`badge badge-${color}`}>{children}</span>
}
